import * as yup from "yup";

export const schema = yup.object({
  primary_logo_rectangle_image: yup.object().nullable(),
  primary_logo_square_image: yup.object().nullable(),
  favicon_image: yup.object().nullable(),
  login_image: yup.object().nullable(),
});
